import React from 'react'
import { Fade, Menu, MenuItem } from '@mui/material'

import Tooltip from '../../../../../atoms/Tooltip'
import useStyles from '../styles'
import RemoveAgentIcon from '../../../../ChatWindowV2/Header/TransferModal/Icon'
import DownArrowSmallIcon from '../../../../../icons/DownArrowSmallIcon'

const EmailChip = ({
  user,
  channel,
  emailChannels = [],
  handleOnRemoveClick,
  setUsers
}) => {
  const [channelsMenuOpen, setChannelsMenuOpen] = React.useState(false)
  const ref = React.useRef<any>()
  const classes = useStyles()

  const handleChannelClick = React.useCallback(
    ch => {
      //click same channel of chip case
      if (ch.id === channel.id) {
        return
      }
      setUsers(old => {
        const alreadyExists = old.some(
          entry => entry.user.id === user.id && entry.channel.id === ch.id
        )
        //means its repeated
        if (alreadyExists) {
          //removes current one, leaves the repeated in the list since its the same channel.
          const indexForRemoval = old.findIndex(
            entry =>
              entry.user.id === user.id && entry.channel.id === channel.id
          )
          const copy = [...old]
          const result = copy
            .slice(0, indexForRemoval)
            .concat(copy.slice(indexForRemoval + 1))
          return result
        }
        return old.map(i => {
          if (i.user.id === user.id && i.channel.id === channel.id) {
            i.channel = ch
          }
          return i
        })
      })
    },
    [setUsers, user, channel]
  )

  return (
    <React.Fragment>
      <div className={classes.chip} ref={ref}>
        {channel.value}
        {emailChannels.length > 1 && (
          <DownArrowSmallIcon
            onClick={() => setChannelsMenuOpen(true)}
            style={{ marginLeft: 6 }}
          />
        )}

        <Tooltip title='Remove from list' arrow>
          <span style={{ display: 'flex' }}>
            <RemoveAgentIcon
              onClick={() => {
                handleOnRemoveClick(user, channel)
              }}
            />
          </span>
        </Tooltip>
      </div>
      {channelsMenuOpen && (
        <Menu
          open={channelsMenuOpen}
          disableEnforceFocus
          anchorEl={ref.current}
          anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
          transformOrigin={{ horizontal: 'center', vertical: 4 }}
          TransitionComponent={Fade}
          classes={{ paper: classes.resultsContainer }}
        >
          <label className={classes.extraChannelsLabel}>Select email</label>
          <div className={classes.extraChannelsResults}>
            {emailChannels.map(channel => {
              return (
                <MenuItem
                  key={`${channel.id}-email-chip`}
                  component='div'
                  className={classes.result}
                  onClick={() => {
                    handleChannelClick(channel)
                    setChannelsMenuOpen(false)
                  }}
                  disableGutters
                >
                  <div>
                    <label className={classes.emailResult}>{user?.name}</label>
                    <label className={classes.emailValue}>
                      {channel?.value}
                    </label>
                  </div>
                </MenuItem>
              )
            })}
          </div>
        </Menu>
      )}
    </React.Fragment>
  )
}

export default EmailChip
